<template>
    <div class="vod-view">
        <VodSidebar />
        <VodNavigation />
        <div class="vod-view-content" v-if="!appLoading">
            <transition name="fade" mode="out-in">
                <router-view :key="$route.path" />
            </transition>
        </div>
    </div>
</template>
<script>
import VodSidebar from '../VOD/VodSidebar'
import VodNavigation from '../VOD/VodNavigation'
export default {
    components: {
        VodSidebar,
        VodNavigation
    },
    data() {
        return {
            appLoading: false
        }
    }
}
</script>
